import { TranslationType } from '../components/HbtPortfolioManagementTable/types';

export const requestTypeMapping = (t: TranslationType) => {
  const mapping = {
    '01': t('Pi-Portfolio-Management-Table-RequestType-Mapping-NP', 'New Portfolio'),
    '02': t('Pi-Portfolio-Management-Table-RequestType-Mapping-Repl', 'Replacement'),
    '04': t('Pi-Portfolio-Management-Table-RequestType-Mapping-Ca', 'Cancellation'),
    '05': t('Pi-Portfolio-Management-Table-RequestType-Mapping-Resub', 'Resubmission')
  };
  return mapping;
};
